import Vue from 'vue'
import {db} from '../firebase'

export default {
    namespaced: true,
    state: {
        messages: []
    },
    mutations: {
        setMessages(state, messages){
            state.messages = messages
        }
    },
    actions: {
        doCreate(context, {name, contact, message, category}){
            const messageId = db.collection('messages').doc().id
            console.log(messageId)
            db.collection('messages').doc(messageId).set({
                name,
                contact,
                message,
                category,
                messageId,
                createdAt: Date.now()
            })
        },
        doDelete({dispatch}, id){
            db.collection('messages').doc(id).delete()
            dispatch('getMessages')
            Vue.$toast.success('El mensaje fue eliminado')
        },
        setRead({dispatch}, id){
            db.collection('messages').doc(id).update({
                read: true
            })
            dispatch('getMessages')
            Vue.$toast.success('El mensaje fue marcado como leído')
        },
        async getMessages({commit, rootState}){
            const messagesAllow = await db.collection('users').doc(rootState.user.user.uid).get()
            const messagesRef = await db.collection('messages').orderBy('createdAt', 'desc').where('category', 'in', messagesAllow.data().messages).get()
            const messages = []
            messagesRef.forEach((message)=>{
                messages.push(message.data())
            })
            commit('setMessages', messages)
        }
    },
}